import Vue from 'vue';
import VueRouter from 'vue-router';
import Login from "@/views/Login.vue";
import Users from "@/views/admin/Users";
import Home from "@/views/user/Home";
import ShoppingCart from "@/views/user/ShoppingCart";
import Warehouses from "@/views/admin/Warehouses";
import Products from "@/views/user/Products";
import NotFound from "@/views/NotFound";
import Admin from "@/views/admin/Admin";
import Brands from "@/views/admin/Brands";
import ProductTypes from '@/views/admin/ProductTypes'
import Summary from '@/views/user/Summary'
import Orders from '@/views/user/Orders'
import Order from '@/views/user/Order'
import BulkOrders from '@/views/user/BulkOrders'
import Carriers from '@/views/admin/Carriers'
import Warehouse from '@/views/admin/Warehouse'
import WarehousesToUser from "@/views/admin/WarehousesToUser";
import Approval from "@/views/approver/Approval";
import BulkOrder from "@/views/user/BulkOrder";
import EditOrder from "@/views/approver/EditOrder";
import EditBulkOrder from "@/views/approver/EditBulkOrder";
import Buyers from "@/views/user/Buyers";
import BuyerAddresses from "@/views/user/BuyerAddresses";
import BulkOrdersImport from "@/views/user/BulkOrdersImport.vue";
import ApproverOrders from "@/views/approver/ApproverOrders.vue";

Vue.use(VueRouter);

const ROLE_BUYER = 'ROLE_BUYER';
const ROLE_APPROVER = 'ROLE_APPROVER';
const ROLE_ADMIN = 'ROLE_ADMIN';

const routes = [
    // login
    {
        path: '/login',
        name: 'login',
        component: Login,
        meta: {isGranted: []}
    },
    // user
    {
        path: '/',
        name: 'home',
        component: Home,
        meta: {isGranted: [ROLE_BUYER]}
    },
    {
        path: '/products',
        name: 'products',
        component: Products,
        meta: {isGranted: [ROLE_BUYER]}
    },
    {
        path: '/cart',
        name: 'shopping-cart',
        component: ShoppingCart,
        meta: {isGranted: [ROLE_BUYER]}
    },
    {
        path: '/bulk-orders',
        name: 'bulk-orders',
        component: BulkOrders,
        meta: {isGranted: [ROLE_BUYER]}
    },
    {
        path: '/summary',
        name: 'summary',
        component: Summary,
        meta: {isGranted: [ROLE_BUYER]}
    },
    {
        path: '/orders',
        name: 'orders',
        component: Orders,
        meta: {isGranted: [ROLE_BUYER]}
    },
    {
        path: '/orders/:orderId',
        name: 'order',
        component: Order,
        meta: {isGranted: [ROLE_BUYER, ROLE_APPROVER]}
    },
    {
        path: '/bulk-orders/:bulkOrderId',
        name: 'bulk-order',
        component: BulkOrder,
        meta: {isGranted: [ROLE_BUYER, ROLE_APPROVER]}
    },
    {
        path: '/bulk-orders-import',
        name: 'bulk-orders-import',
        component: BulkOrdersImport,
        meta: {isGranted: [ROLE_BUYER]}
    },
    {
        path: '/buyers',
        name: 'buyers',
        component: Buyers,
        meta: {isGranted: [ROLE_BUYER]}
    },
    {
        path: '/buyers/:buyerId/addresses',
        name: 'buyer-addresses',
        component: BuyerAddresses,
        meta: {isGranted: [ROLE_BUYER]}
    },
    // admin
    {
        path: '/admin',
        name: 'admin',
        component: Admin,
        meta: {isGranted: [ROLE_ADMIN]}
    },
    {
        path: '/admin/users',
        name: 'users',
        component: Users,
        meta: {isGranted: [ROLE_ADMIN]}
    },
    {
        path: '/admin/brands',
        name: 'brands',
        component: Brands,
        meta: {isGranted: [ROLE_ADMIN]}
    },
    {
        path: '/admin/warehouses',
        name: 'warehouses',
        component: Warehouses,
        meta: {isGranted: [ROLE_ADMIN]}
    },
    {
        path: '/admin/warehouses/:warehouseId',
        name: 'warehouse',
        component: Warehouse,
        meta: {isGranted: [ROLE_ADMIN]}
    },
    {
        path: '/admin/users/:userId/warehouses',
        name: 'warehouses-to-user',
        component: WarehousesToUser,
        meta: {isGranted: [ROLE_ADMIN]}
    },
    {
        path: '/admin/product-types',
        name: 'product-types',
        component: ProductTypes,
        meta: {isGranted: [ROLE_ADMIN]}
    },
    {
        path: '/admin/carriers',
        name: 'carriers',
        component: Carriers,
        meta: {isGranted: [ROLE_ADMIN]}
    },
    // approver
    {
        path: '/approver/approval',
        name: 'approval',
        component: Approval,
        meta: {isGranted: [ROLE_APPROVER]}
    },
    {
        path: '/approver/orders',
        name: 'approver-orders',
        component: ApproverOrders,
        meta: {isGranted: [ROLE_APPROVER]}
    },
    {
        path: '/approver/orders/:orderId',
        name: 'edit-order',
        component: EditOrder,
        meta: {isGranted: [ROLE_APPROVER]}
    },
    {
        path: '/approver/bulk-orders/:bulkOrderId',
        name: 'edit-bulk-order',
        component: EditBulkOrder,
        meta: {isGranted: [ROLE_APPROVER]}
    },
    // 404
    {
        path: '/404',
        name: 'not-found',
        component: NotFound,
        meta: {isGranted: []}
    },
    // default route
    {
        path: '*',
        redirect: '/404'
    }
];

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
});

export default router;
